<template>
  <v-dialog v-model="dialog" max-width="600" persistent>
    <template v-slot:activator="{ on }">
      <v-btn
        :disabled="disabled"
        color="primary"
        outlined
        class="mb-2"
        :fab="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm"
        :small="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm"
        v-on="on"
        @click="open"
      >
        <v-icon :left="!($vuetify.breakpoint.xs || $vuetify.breakpoint.sm)">
          mdi-plus
        </v-icon>
        <template v-if="!($vuetify.breakpoint.xs || $vuetify.breakpoint.sm)">
          New user
        </template>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text class="pt-1">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row class="px-4">
            <v-col cols="12">
              <div class="subtitle">
                An email will be sent to this user containing all the
                information needed to signin.
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row dense>
                <!-- <v-col cols="12" class="my-0 py-0">
                <v-text-field
                  v-model="user.username"
                  name="username"
                  label="Utilisateur"
                  outlined
                  :error-messages="errors.username"
                  @blur="$v.user.email.$touch()"
                />
              </v-col> -->

                <v-col cols="12" class="my-0 py-0">
                  <v-text-field
                    v-model="user.first_name"
                    name="first_name"
                    label="First name*"
                    :rules="[v => !!v || 'First name is required']"
                    outlined
                  />
                </v-col>
                <v-col cols="12" class="my-0 py-0">
                  <v-text-field
                    v-model="user.last_name"
                    name="last_name"
                    label="Last name"
                    outlined
                  />
                </v-col>
                <v-col cols="12" class="my-0 py-0">
                  <v-text-field
                    v-model="user.email"
                    :rules="[
                      v => email(v) || 'Email is not valid',
                      v => !!v || 'Email is required'
                    ]"
                    name="email"
                    label="Email*"
                    outlined
                    @blur="$v.user.email.$touch()"
                  />
                </v-col>
                <v-col cols="12" class="mb-0 mt-1 py-0">
                  <div class="subtitle-1">
                    <v-icon left>mdi-lock</v-icon>
                    Permissions
                  </div>
                </v-col>
                <!-- 
                <v-col cols="12" class="my-2 py-0">
                  <v-checkbox
                    v-model="user.is_admin"
                    label="Grant administrator privileges (has access to all brands)"
                    color="primary"
                    @change="
                      () => {
                        user.groups = ''
                        if (user.role == 'Admin')
                          this.$refs.form.resetValidation()
                      }
                    "
                  ></v-checkbox>
                </v-col> -->

                <v-col cols="12" class="my-2 py-0">
                  <v-autocomplete
                    :rules="[v => !!v || 'Role is required']"
                    clearable
                    label="Role"
                    item-text="type"
                    item-value="type"
                    v-model="user.role"
                    :items="roles"
                    outlined
                    @change="
                      () => {
                        user.groups = ''
                        if (user.role == 'Admin')
                          this.$refs.form.resetValidation()
                      }
                    "
                  >
                    <template v-slot:item="data">
                      <template>
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="data.item.type"
                          ></v-list-item-title>
                          <v-list-item-subtitle
                            v-html="data.item.description"
                          ></v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" class="my-0 py-0">
                  <v-autocomplete
                    :rules="[
                      user.role == 'Admin'
                        ? v => true
                        : v => !!v || 'Brand is required'
                    ]"
                    :disabled="user.role == 'Admin'"
                    clearable
                    label="Brands"
                    item-text="label"
                    item-value="id"
                    return-object
                    v-model="user.groups"
                    :items="companyGroups"
                    outlined
                    multiple
                    :search-input.sync="searchInput"
                    @change="searchInput = ''"
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />

        <v-btn @click="close" text>
          Annuler
        </v-btn>
        <v-btn
          class="primary--text"
          depressed
          :disabled="saveLoader"
          @click="save"
          :loading="saveLoader"
        >
          Enregistrer
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import MerchantInput from '@/components/inputs/MerchantInput'
import CompanyGroupService from "@/services/hmd/CompanyGroupService"
import CompanyService from "@/services/hmd/CompanyService"
import { required, email } from "vuelidate/lib/validators"
import { validationMixin } from "vuelidate"
import { cloneDeep } from "lodash"
export default {
  components: {
    // MerchantInput,
  },
  mixins: [validationMixin],
  validations: {
    user: {
      email: { required, email },
      first_name: {},
      last_name: {},
      groups: { required },
      role: { required }
    },
    validationGroup: ["user"]
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {
          pk: null,
          email: "",
          first_name: "",
          last_name: "",
          groups: [],
          role: null
        }
      }
    }
  },
  data() {
    return {
      searchInput: "",
      valid: false,
      dialog: false,
      companyGroups: [],
      roles: [
        {
          type: "Admin",
          description: "Has access to all brands and all products",
          value: "is_admin"
        },
        {
          type: "Brand User",
          description:
            "Has access to all the brands assigned to him and all their products",
          value: "is_brand_user"
        },
        {
          type: "Contributor",
          description:
            "Can modify and create products for the brands assigned to him",
          value: "is_contributor"
        },
        {
          type: "Viewer",
          description: "Can view the products for the brands assigned to him",
          value: "is_viewer"
        }
      ],
      user: {
        pk: null,
        email: "",
        groups: null,
        first_name: "",
        last_name: "",
        role: null
      },
      saveLoader: false
    }
  },
  computed: {
    formTitle() {
      return this.user.pk ? "Edit user" : "Create new user"
    },
    errors() {
      const $ = this
      const errs = {
        email: [],
        groups: []
      }
      if ($.$v.user.email.$dirty) {
        !$.$v.user.email.required && errs.email.push("Email is required")
        !$.$v.user.email.email && errs.email.push("Email is not valid")
      }

      if ($.$v.user.groups.$dirty) {
        !$.$v.user.groups.required && errs.groups.push("Brand is required")
      }
      return errs
    }
  },
  mounted() {
    this.getCompanyGroups()
  },
  watch: {
    value(newValue) {
      if (newValue.pk) {
        let roleFound = null
        let rolesAttributes = ['is_admin', 'is_brand_user', 'is_contributor', 'is_viewer']
        rolesAttributes.every(r => {
          if (newValue[r] === true) {
            roleFound = r
            return false
          }
          return true
        })
        const temp = cloneDeep(newValue)
        let roleType = null
        let groups = []
        if (roleFound) {
          const role = this.roles.find(v => v.value == roleFound)
          roleType = role.type
          groups = temp.groups.map(g => ({
            id: g.id,
            label: this.lo.startCase(g.name),
            name: g.name
          }))       
        }
        this.user = {
          ...temp,
          role: roleType,
          groups: groups
        }
        this.dialog = true
      }
    },

    dialog(newVal, oldVal) {
      if (newVal) {
        this.getCompanyGroups()
      }
    }
  },
  methods: {
    required,
    email,
    getCompanyGroups() {
      CompanyGroupService.list_group_company(this).then(r => {
        this.companyGroups = r
          .filter(f => !["ASD_default_group"].includes(f.name))
          .map(o => ({ ...o, label: o.name }))
      })
    },
    open() {
      this.$v.$reset()
    },
    reset() {
      this.user = {
        id: null,
        email: "",
        groups: [],
        role: null,
        first_name: "",
        last_name: "",
        merchant: this.user.merchant || ""
      }
      this.$refs.form.resetValidation()
    },
    close() {
      this.dialog = false
      this.reset()
      this.$emit("closed")
      this.$refs.form.resetValidation()
    },
    // async handleUserGroupCreateUpdate(user, isCreate = false) {
    //   const $ = this
    //   if (isCreate && (!user.groups || user.groups?.length <= 0)) return
    //   const oldGroups = $.value.groups || []
    //   let promises = []
    //   if (user.pk != null) {
    //     // update (create/update/delete)
    //     // virer celles qui ont été déselectionné
    //     oldGroups
    //       .filter(g => !user.groups.map(g2 => g2.pk).includes(g.id))
    //       .map(g => {
    //         promises.push(
    //           new Promise((resolve, reject) => {
    //             CompanyGroupService.remove_member_group_company(
    //               $,
    //               g.id,
    //               user.pk
    //             )
    //               .then(r => resolve(r))
    //               .catch(err => reject(err))
    //           })
    //         )
    //       })
    //     // créer les nouvelles
    //     user.groups
    //       .filter(g => !oldGroups.map(g2 => g2.pk).includes(g.id))
    //       .map(g => {
    //         promises.push(
    //           new Promise((resolve, reject) => {
    //             CompanyGroupService.add_member_group_company($, g.id, user.pk)
    //               .then(r => resolve(r))
    //               .catch(err => reject(err))
    //           })
    //         )
    //       })
    //   } else {
    //     // create
    //     user.groups.map(g =>
    //       promises.push(
    //         new Promise((resolve, reject) => {
    //           CompanyGroupService.add_member_group_company($, g.id, user.pk)
    //             .then(r => resolve(r))
    //             .catch(err => reject(err))
    //         })
    //       )
    //     )
    //   }
    //   for (const promise of promises) {
    //     await Promise.resolve(promise)
    //   }
    // },
    save() {
      this.$refs.form.validate()
      this.$nextTick(() => {
        if (this.valid) {
          let userValue = {
            company: this.user.company,
            pk: this.user.pk,
            is_admin: this.user.role == "Admin",
            is_brand_user: this.user.role == "Brand User",
            is_contributor: this.user.role == "Contributor",
            is_viewer: this.user.role == "Viewer",
            email: this.user.email,
            first_name: this.user.first_name,
            last_name: this.user.last_name,
            groups:
              this.user.role == "Admin"
                ? null
                : this.user.groups.map(g => g.name),
            username: this.user.username
          }

          this.saveLoader = true
          if (userValue.pk != null) {
            CompanyService.User.update(this, userValue, userValue.pk)
              .then(r => {
                //  this.handleUserGroupCreateUpdate(userValue)
                this.$emit("updated")
                this.close()
              })
              .catch(error => {})
              .finally(() => {
                this.saveLoader = false
              })
          } else {
            CompanyService.User.create(this, userValue)
              .then(async r => {
                //  this.handleUserGroupCreateUpdate(r, true)
                this.$emit("created")
                this.close()
              })
              .finally(() => {
                this.saveLoader = false
              })
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
